import { render, staticRenderFns } from "./bulk-import.vue?vue&type=template&id=09f54b62&scoped=true"
import script from "./bulk-import.vue?vue&type=script&lang=js"
export * from "./bulk-import.vue?vue&type=script&lang=js"
import style0 from "./bulk-import.vue?vue&type=style&index=0&id=09f54b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f54b62",
  null
  
)

export default component.exports